import shortid from "shortid";

const makeId = () => shortid.generate();
export const generatedId = () => `${makeId()}${makeId()}${makeId()}`;
